export default __webpack_public_path__ + "static/media/landing_slider_2.35da70d3.jpg";